<template>
  <div class="swiper-box">
    <el-carousel indicator-position="outside" arrow="never" height="25rem">
      <el-carousel-item v-for="i in 1" :key="i">
        <div class="swiper-wrap">
          <div
            class="swiper-item"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div style="width: 18.125rem; height: 13.4375rem; overflow: hidden">
              <img :src="item.img" class="icon hvr-grow" alt="" />
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    indexNum: {
      type: Number,
    },
  },
  data() {
    return {
      swiperList: [],
    };
  },
  mounted() {
    switch (this.indexNum) {
      case 1:
        this.swiperList = [
          {
            img: require("@/assets/case/com (4).png"),
            title: "山禾泉品牌设计",
            text: "品牌设计",
          },
          {
            img: require("@/assets/case/com (3).png"),
            title: "思芝谷教育品牌设计",
            text: "品牌设计",
          },
          {
            img: require("@/assets/case/com (2).png"),
            title: "乐讯品牌设计",
            text: "品牌设计",
          },
          {
            img: require("@/assets/case/com (1).png"),
            title: "联瑞科技品牌设计",
            text: "品牌设计",
          },
        ];
        break;
      case 2:
        this.swiperList = [
          {
            img: require("@/assets/case/sys (1).png"),
            title: "检察院 排位系统",
            text: "系统开发",
          },
          {
            img: require("@/assets/case/sys (2).png"),
            title: "环保局OA管理系统",
            text: "系统开发",
          },
        ];
        break;
    }
  },
};
</script>
<style scoped>
.swiper-box {
  margin: 0 20.625rem;
  padding: 5rem 0 0;
}

.swiper-wrap {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.swiper-wrap .swiper-item {
  margin-right: 2.0625rem;
}

.swiper-wrap .swiper-item .icon {
  width: 18.125rem;
  height: 13.4375rem !important;
}

.swiper-wrap .swiper-item .title {
  font-weight: 400;
  font-size: 1rem;
  color: #ffffff;
  margin: 2.1875rem 0 1.25rem;
}

.swiper-wrap .swiper-item .text {
  font-weight: 400;
  font-size: 0.75rem;
  color: #ffffff;
  opacity: 0.3;
}
</style>
